var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "site-footer" }, [
    _c("div", { staticClass: "container footer-inner" }, [
      _c("div", { staticClass: "footer-brand" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/images/logo.png"),
            alt: _vm.$t("site.copy291"),
            loading: "lazy"
          }
        }),
        _vm._v(" "),
        _c("div", [
          _c("p", { staticClass: "footer-name" }, [
            _vm._v(_vm._s(_vm.$t("site.copy292")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "footer-slogan" }, [
            _vm._v(_vm._s(_vm.$t("site.copy293")))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container footer-bottom" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("site.copy303")))]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("蒙ICP备2026002238号-1")]
      ),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("site.copy304")))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62fe346e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fe346e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
// module id = null
// module chunks = 